// extracted by mini-css-extract-plugin
export default {"skill":"Skill_skill__KVkTL","reactLogo":"Skill_reactLogo__QAx5p","skillGrid":"Skill_skillGrid__v5T75","skillItem":"Skill_skillItem__DS3fu","ReactTitle":"Skill_ReactTitle__mhH6M"};